<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if="!isFilterDisabled()">
            <a-form-item label="设备">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id, del_flag=0 order by sort asc"
                placeholder="请选择加水点"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if="!isFilterDisabled()">
            <a-form-item label="企业">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if="!isFilterDisabled()">
            <a-form-item label="班组">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="groupChange"
                placeholder="请选择班组"
                v-model="queryParam.groupId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if="!isFilterDisabled()">
            <a-form-item label="用户">
              <j-search-select-tag
                :dictOptions="consUserOptions"
                @change="searchQuery"
                placeholder="请选择用户"
                v-model="queryParam.userId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="操作类型">
              <a-input placeholder="请输入操作类型" v-model="queryParam.operationType"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24" :xl="12">
            <a-form-item label="操作时间">
              <j-date
                :show-time="true"
                class="query-group-cust"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择开始时间"
                v-model="queryParam.operationTime_begin"
              ></j-date>
              <span class="query-group-split-cust"></span>
              <j-date
                :show-time="true"
                class="query-group-cust"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择结束时间"
                v-model="queryParam.operationTime_end"
              ></j-date>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="!isFilterDisabled()">
      <a-button @click="handleExportXls('APP用户操作记录')" icon="download" type="primary">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-if="bizType == ''">详情</a>

          <a
            @click="selectConsumerUser(record, 'startTime')"
            v-if="bizType == 'repair' && record.operationType.includes('开阀')"
          >开阀操作</a>
          <a
            @click="selectConsumerUser(record, 'endTime')"
            v-if="bizType == 'repair' && record.operationType.includes('关阀')"
          >关阀操作</a>
        </span>
      </a-table>
    </div>

    <wf-consumer-user-operation-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-user-operation-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerUserOperationModal from './modules/WfConsumerUserOperationModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerUserOperationList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerUserOperationModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      },
      bizType: {
        type: String,
        default: '',
      }
    },
    watch: {
      filter: {
        handler () {
          this.searchQuery();
        },
        deep: true
      }
    },
    computed: {

    },
    data () {
      return {
        description: 'APP用户操作记录管理页面',
        isorter: {
          column: 'createTime',
          order: 'desc'
        },
        ipagination: {
          pageSize: 50,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '用户',
            align: "center",
            sorter: true,
            dataIndex: 'userId_dictText'
          },
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '操作类型',
            align: "center",
            sorter: true,
            dataIndex: 'operationType'
          },
          {
            title: '操作时间',
            align: "center",
            sorter: true,
            dataIndex: 'operationTime'
          },
          {
            title: '企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '班组',
            align: "center",
            sorter: true,
            dataIndex: 'groupId_dictText'
          },
          {
            title: '操作信息',
            align: "center",
            dataIndex: 'operationInfo'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 80,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/userOperation/list",
          delete: "/wf/userOperation/delete",
          deleteBatch: "/wf/userOperation/deleteBatch",
          exportXlsUrl: "/wf/userOperation/exportXls",
          importExcelUrl: "wf/userOperation/importExcel",
          corpGroupList: 'wf/corpGroup/list',
          corpUserList: "/custom/user/list",
        },
        consUserOptions: [],
        consGroupOptions: [],
        superFieldList: [],
        localFilter: {},
      }
    },
    created () {
      this.getSuperFieldList();

      this.getConsGroup();
      this.getConsUser();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      selectConsumerUser (record, timeKey) {
        const userInfo = {
          id: record.userId,
          corpId: record.corpId,
          groupId: record.groupId
        }
        userInfo[timeKey] = record.operationTime;
        this.$emit('selectConsumerUser', userInfo);
      },
      isFilterDisabled () {
        return this.filter && this.filter.disabled === true
      },
      //因为查询条件重置功能会清空queryParam，所以需要重写loadData方法，把固定的查询条件加进去
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      corpChange () {
        this.queryParam.groupId = null;
        this.queryParam.userId = null;
        this.searchQuery();
        this.getConsGroup();
        this.getConsUser();
      },
      groupChange () {
        this.queryParam.userId = null;
        this.searchQuery();
        this.getConsUser();
      },
      getConsGroup () {
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getConsUser () {
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          groupId: this.queryParam.groupId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'userId', text: '用户', dictCode: '`iwt-wf`.wf_consumer_user,nickname,id' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备', dictCode: '' })
        fieldList.push({ type: 'string', value: 'operationType', text: '操作类型', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'operationTime', text: '操作时间' })
        fieldList.push({ type: 'string', value: 'corpId', text: '企业', dictCode: '' })
        fieldList.push({ type: 'string', value: 'groupId', text: '班组', dictCode: '' })
        fieldList.push({ type: 'Text', value: 'operationInfo', text: '操作信息', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>